<template>
    <ValidationProvider
        :name="$t('formularios.tipo_identificacion') + (index > 0 ? (' ' + index) : '')"
        :rules="required ? 'required' : ''"
        v-slot="{ errors }"
    >
        <div class="form-group">
            <label>{{ $t('formularios.tipo_identificacion') }}</label>
            <multiselect
                v-model="localType"
                label="label"
                track-by="type"
                class="rounded-pill"
                :disabled="disabled"
                :class="{ 'is-invalid': errors.length }"
                :id="'tipo-documento-' + index"
                :data-cy="'tipo-documento-' + index"
                :placeholder="$t('formularios.tipo_identificacion')"
                :options="tiposDocumento"
                @input="onSelect"
            />
            <span
                v-if="errors[0]"
                class="p-2 mb-4 text-xs d-block invalid-feedback bg-danger white h7 font-weight-bold"
            >
                {{ errors[0] }}
            </span>
        </div>
    </ValidationProvider>
</template>

<script setup>

    import { ref, watch } from 'vue';

    const props = defineProps({
        value: {
            type: String,
            default: ''
        },
        index: {
            type: Number,
            default: 0
        },
        disabled: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: true
        }
    });

    const emit = defineEmits(['input']);

    const tiposDocumento = [
        { type: 'DNI', label: 'DNI' },
        { type: 'NIE', label: 'NIE'},
        { type: 'NIF', label: 'NIF' },
        { type: 'PASAPORTE', label: 'PASAPORTE' },
        { type: 'OTROS', label: 'OTROS' }
    ];

    const localType = ref(
        tiposDocumento.find(opt => opt.type === props.value) || null
    );

    watch(() => props.value, newVal => {
        const match = tiposDocumento.find(opt => opt.type === newVal);
        if (localType.value?.type !== newVal) {
            localType.value = match || null;
        }
    });

    const onSelect = option => {
        localType.value = option;
        emit('input', option ? option.type : '');
    };
</script>
<style scoped>
    .multiselect {
        width: 100%;
        border-radius: 50px;
        border: 1px solid #ced4da;
        min-height: 38px;
        height: auto;
        background-color: #fff;
        padding: 0;
        font-size: 14px;
    }

    .multiselect:focus-within {
        border-color: #80bdff;
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }

    .multiselect.is-invalid {
        border-color: #dc3545;
    }

    .multiselect.is-invalid:focus-within {
        box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, 0.25);
    }

    /deep/ .multiselect > .multiselect__tags {
        background-color: white;
        border: none;
        border-radius: 50px;
        min-height: 36px;
        padding: 0.375rem 2.5rem 0.375rem 0.75rem;
        font-size: 14px;
    }

    /deep/ .multiselect > .multiselect__tags > .multiselect__single {
        background-color: transparent;
        padding: 0;
        margin: 0;
        line-height: 1.5;
        font-size: 14px;
        color: #495057;
    }

    /deep/ .multiselect > .multiselect__select {
        height: 36px;
        width: 36px;
        padding: 0;
    }

    /deep/ .multiselect > .multiselect__select:before {
        border: none;
        content: "▼";
        font-size: 10px;
        color: #495057;
        position: absolute;
        right: 12px;
        top: 50%;
        transform: translateY(-50%);
    }

    /deep/ .multiselect > .multiselect__content-wrapper {
        right: 0;
        border-radius: 0.5rem;
        border: 1px solid #ced4da;
        margin-top: 4px;
    }

    /* Responsive mobile styles */
    @media (max-width: 576px) {
        .multiselect {
            border-radius: 30px;
            min-height: 36px;
            font-size: 13px;
        }

        /deep/ .multiselect > .multiselect__tags {
            border-radius: 30px;
            min-height: 34px;
            padding: 0.25rem 2rem 0.25rem 0.5rem;
            font-size: 13px;
        }

        /deep/ .multiselect > .multiselect__tags > .multiselect__single {
            font-size: 13px;
        }

        /deep/ .multiselect > .multiselect__select {
            height: 34px;
            width: 34px;
        }

        /deep/ .multiselect > .multiselect__select:before {
            right: 8px;
            font-size: 8px;
        }
    }
</style>
